/* ---------- Create Checklist toaster component ------------------

    -   This component is used for when the user wants to create a custom checklist. 
*/


// ------------------ React Components ------------------------
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// -------------------- API -----------------------------
import API_BASE_URL from "../../utils/api/apiConfig.js";

// --------------------- icons --------------------
import { MdDeleteOutline } from "react-icons/md";
import { FaSpinner } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { MdOutlineCancel } from "react-icons/md";
import { CiEdit } from "react-icons/ci";


// --------------------- Assests -------------------
import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png'; 

// ------------------- Application components --------------------

import ItemAddedToaster from "../../toasterscomponents/checklistToasters/ItemAddedToaster.js";
import ItemRemovedToaster from "../../toasterscomponents/checklistToasters/ItemRemovedToaster.js";
import CreatedSuccesFullyToaster from "../../toasterscomponents/shepacktoasters/CreatedSuccesFullyToaster.js";


// --------------------- Component - Add Questions Create Checklist -------------------
const EditTemplateComponent = ({ formName, checklistUniqueIdentifier }) => {

    //
    const [templateLoaded, setTemplateLoaded] = useState(false);

    const [showSuccess, setShowSuccess] = useState(false);

    // State Management - SHE Packs
    const [shePacks, setShePacks] = useState([]);
    const [selectedSHEPack, setSelectedSHEPack] = useState("");

    // State Management - SHE Pack Documents
    const [isPackSelected, setIsPackSelected] = useState(false);

    //
    const [selectedDocument, setSelectedDocument] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    //
    const [documents, setDocuments] = useState([]);
     // State Management - Loading spinner 
  const [isLoading, setIsLoading] = useState(true);
  const [editError, setEditError] = useState("");
    
    

    //
    const user = JSON.parse(sessionStorage.getItem('user'));

    const [viewSection, setViewSection] = useState({ A: true, B: false, C: false });

    // --------------- State Managements ------------------------

    // state management - Section A checklist information
    const [checklistName, setDocumentName] = useState("");
    const [newDuplicateName, setNewDuplicateName] = useState("");
    

    // state management - Section categories
    const [editingCategory, setEditingCategory] = useState(null);
    const [editedCategoryName, setEditedCategoryName] = useState("");

    // state management - section Create questions 
    const [visibleOptions, setVisibleOptions] = useState(3);
    const [submitStatus, setSubmitStatus] = useState('idle');
    const [errors, setErrors] = useState([]);
    
    const [questionTypes] = useState(['Free Text']);
    const [questionBankData, setQuestionBankData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [optionError, setOptionError] = useState("");
    const [showToaster, setShowToaster] = useState({ success: false, categoryAdded: false, rowAdded: false, rowRemoved: false, optionAdded: false, editedCategory: false, cancelEditedCategory: false });
    const [totalScore, setTotalScore] = useState(0);
    //
    const navigate = useNavigate();

    // Handle edit button click
    const handleSelectSHEpack = () => {
        if (!selectedSHEPack) {
            setEditError("Please select a SHE File.");
            return;
        }
    
        setShowToaster(prev => ({ ...prev, fileSelected: true }));
        setEditError("");
        setIsPackSelected(true);
    };
    

    useEffect(() => {

        const fetchEditableDocuments = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/template/edit-template/get-templates`);
                
                // Only set checklists if data is an array
                if (Array.isArray(response.data)) {
                    setDocuments(response.data);
                } else {
                    console.error('Invalid response format', response.data);
                    setDocuments([]);
                }
                
                setIsLoading(false);

            } catch (error) {

                console.error('Error fetching editable checklists:', error);
                setEditError(error.response?.data?.message || 'Failed to load checklists');
                setIsLoading(false);
                setDocuments([]);

            }
        };
    
        fetchEditableDocuments();
    }, []); // Empty dependency array means this runs once on component mount

    // Function to fetch checklist data
    const fetchChecklistData = async (documentId) => {

        console.log("Fetching checklist data for checklistId:", documentId);

        setIsLoading(true);
        setEditError("");
        
        try {
            // Check if a checklist is selected
            if (!documentId) {
                
                setIsLoading(false);
                return;
            }
    
            const response = await axios.get(`${API_BASE_URL}/duplicate-template/get-questions/question-bank/${documentId}`);
            
            if (response.data && response.data.length > 0) {

                // Update state with fetched data
                setQuestionBankData(response.data);
                setDocumentName(response.data[0].shepack_document_name);
                
                // Extract and set categories
                const uniqueCategories = [...new Set(response.data.map(item => item.category))];
                setCategories(uniqueCategories.filter(Boolean) || ['General']);
    
                // Find maximum number of options used
                const maxOptions = Math.max(...response.data.map(row => {
                    let maxUsed = 0;
                    for (let i = 1; i <= 15; i++) {
                        if (row[`option_${i}`]) maxUsed = i;
                    }
                    return maxUsed;
                }));
                
                setVisibleOptions(Math.max(maxOptions, 3)); // Ensure at least 3 options are visible
                
                setIsEditing(true);
            } else {
                setEditError("No data found for this checklist or checklist might have been already filled");
            }
        } catch (error) {
            console.error('Error fetching checklist data:', error);
            setEditError(`Error loading checklist: ${error.response?.data?.message || error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
            calculateTotalScore();
        }, [questionBankData]);

    // Function to calculate total score
    const calculateTotalScore = () => {
        const total = questionBankData.reduce((sum, question) => {
            const score = parseFloat(question.question_score) || 0;
            return sum + score;
        }, 0);
        setTotalScore(total);
    };

    // Handle edit button click
    const handleEditClick = () => {
        if (!selectedDocument) {
            setEditError("Please select a template to edit");
            return;
        }
        setEditError("");
        fetchChecklistData(selectedDocument);
        setTemplateLoaded(true); // Set template loaded to true instead of using isEditing
    };
    

    useEffect(() => {
        fetchChecklistData()
        fetchQuestionBankData();
        
    }, []);

    useEffect(() => {

        const fetchShePacks = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/she-file/duplicate-template/get-she-packs`);
                
                // Only set checklists if data is an array
                if (Array.isArray(response.data)) {
                    setShePacks(response.data);
                } else {
                    console.error('Invalid response format', response.data);
                    setShePacks([]);
                }
                
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching SHE File:', error);
                setEditError(error.response?.data?.message || 'Failed to load File');
                setIsLoading(false);
                setShePacks([]);
            }
        };
    
        fetchShePacks();
    }, []); // Empty dependency array means this runs once on component mount


    useEffect(() => {
        const timers = Object.keys(showToaster).map(key => showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000));
        return () => timers.forEach(timer => clearTimeout(timer));
    }, [showToaster]);

    const fetchQuestionBankData = async () => {
        try {
            const columnsResponse = await axios.get(`${API_BASE_URL}/columns/Question_Bank`);
            setColumns(columnsResponse.data);
        } catch (error) {
            console.error('Error fetching Question Bank data:', error);
        }
    };

    //
    

    const handleReset = () => {
        // Reset all form-related states to their initial state
        setDocumentName("");
        
        // Instead of using initializePredefinedQuestions(), we'll start completely from scratch
        setQuestionBankData([]);
        
        // Reset categories to default
        setCategories(['General']);
        
        // Reset other related states
        setNewCategory("");
        setCategoryError("");
        setErrors([]);
        
        // Reset view sections
        setViewSection({ A: true, B: false, C: false });
    };

    const handleClearQuestions = () => {
        
        // Instead of using initializePredefinedQuestions(), we'll start completely from scratch
        setQuestionBankData([]);

        // Reset categories to default
        setCategories(['General']);
        
    
        // Reset other related states
        setNewCategory("");
        setCategoryError("");
        setErrors([]);
        
       
    };


    const handleInputChange = (rowIndex, columnName, value) => {
        const updatedData = [...questionBankData];
        updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
        setQuestionBankData(updatedData);
    };

    

    const handleAddRow = () => {
        const newRow = {
            checklist_id: checklistUniqueIdentifier,
            checklist_name: formName,
            question_type: 'Free Text', // Changed from 'Radio' to 'Free Text'
            category: '' // Set default category to empty string
        };
    
        setShowToaster(prev => ({ ...prev, rowAdded: true }));
        setQuestionBankData([...questionBankData, newRow]);
    };

    // Handle Submit all Questions
    // Handle Submit all Questions
    const handleSubmit = async () => {
        setSubmitStatus('loading');
        setErrors([]);
        
        let newErrors = [];
        
        if (questionBankData.length === 0) {
            newErrors.push("No Questions - Add at least one question row to the template.");
        }
    
        if (newErrors.length > 0 || !validateData()) {
            setErrors(prevErrors => [...prevErrors, ...newErrors]);
            window.scrollTo(0, 0);
            setSubmitStatus('idle');
            return;
        }
      
        try {
            if (!user || !user.user_id) {
                throw new Error('User session data is missing');
            }
    
            // Find the selected document details
            const selectedDocDetails = documents.find(doc => doc.shepack_document_id === selectedDocument);
            if (!selectedDocDetails) {
                throw new Error('Selected template not found');
            }
            
            // Log the document details for debugging
            console.log("Selected document details:", selectedDocDetails);
    
            // Get shepack_id and shepack_name from the selected document
            const shepack_id = selectedDocDetails.shepack_id;
            const shepack_name = selectedDocDetails.shepack_name;
    
            // Prepare question data with shepack_id and shepack_name included for each question
            const preparedQuestionData = questionBankData.map(question => {
                // Start with all valid fields from the question
                const validFields = {...question};
                
                // Add the shepack_id and shepack_name to each question
                validFields.shepack_id = shepack_id;
                validFields.shepack_name = shepack_name;
                
                return validFields;
            });
    
            // API request with all necessary information from the selected document
            const response = await axios.put(`${API_BASE_URL}/api/template/update-shepack-details/${selectedDocument}`, {
                shepack_document_name: selectedDocDetails.shepack_document_name,
                shepack_document_score: totalScore,
                shepack_id: shepack_id,
                shepack_name: shepack_name,
                created_by: user.user_id,
                questionBankData: preparedQuestionData
            });
    
            console.log('Template updated successfully:', response.data);
            setShowToaster(prev => ({ ...prev, success: true }));
            setSubmitStatus('success');
            setShowSuccess(true);
    
            setTimeout(() => {
                setShowToaster(prev => ({ ...prev, success: false }));
                navigate('/she-pack/she-pack-management');
            }, 2000);
    
        } catch (error) {
            console.error('Error updating template:', error);
            setErrors(prevErrors => [...prevErrors, `Error updating template: ${error.message}`]);
            setSubmitStatus('error');
        }
    };

    const handleAddCategory = () => {
        if (newCategory.trim() === "") {
            setCategoryError("Empty Field - To save category, please enter a category name.");
            return;
        }
        if (!categories.includes(newCategory)) {
            setCategories([...categories, newCategory]);
            setNewCategory("");
            setShowToaster(prev => ({ ...prev, categoryAdded: true }));
            setCategoryError("");
        } else {
            setCategoryError("Duplicate Entry - This category already exists.");
        }
    };

    const handleRemoveRow = (rowIndex) => {
        // Remove row without any restrictions
        setShowToaster(prev => ({ ...prev, rowRemoved: true }));
        setQuestionBankData(questionBankData.filter((_, index) => index !== rowIndex));
    };

    

    const validateData = () => {
        const newErrors = [];
        
        questionBankData.forEach((row) => {
            if (!row.question_name || row.question_name.trim() === '') 
                newErrors.push("Error - Question Name : Question name cannot be empty.");
            // No need to validate options
        });
    
        setErrors(newErrors);
        return newErrors.length === 0;
    };

    

    

    

    const visibleColumnNames = [
        
        'Remove',
        'question_type',
        'question_name',
        'question_reference',
        'question_score',
        'category',
        'is_File_required',
        'comment'
        

    ];

    return (

        <div className="add-question-custom-field-main-component-container">
            
            <div className="add-question-create-questions-checklist-custom-field-component-container">

                <div className="create-questions-custom-field-container">

                    <div className="add-question-view-checklist-component-container">
                        
                        <div className="add-question-view-checklist-header-container">

                            <div>
                                <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
                            </div>

                            <div className="navigate-back-button-container">
                                <button className="navigate-back-button" onClick={() => navigate(-1)}>Back</button>
                            </div>

                        </div>

                        <div className="add-question-view-checklist-header-step-container">
                            <div>
                                <h2>Legal Compliance - <span className="secondary-color-paragraph">Edit Template</span></h2>
                                <p>Edit the details of an existing template that has not yet been completed by a consultant.</p>
                                <p className="secondary-color-paragraph">Complete each section, click on the 'Maximize' button to expand the section.</p>
                            </div>
                        </div>

                        {['A', 'B', 'C'].map(section => (
                            <div key={section} className="create-checklist-section-a-information-main-container">
                                <div className="create-checklist-section-container-main-container">
                                    <div className="create-checklist-section-container">
                                        <div>
                                            <h3>Section {section} - {section === 'A' ? 'Information' : section === 'B' ? 'Categories' : 'Edit Questions'}</h3>
                                        </div>
                                        <div>
                                            <button className="confirm-button" onClick={() => setViewSection(prev => ({ ...prev, [section]: !prev[section] }))}>
                                                {viewSection[section] ? 'Minimize' : 'Maximize'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* View sections  */}
                                {viewSection[section] && (
                                    section === 'A' ? (
                                        <div className="create-checklist-section-a-information-container">
                                            <div className="create-checklist-section-a-information-container-container">

                                                <div>

                                                    <div>

                                                        <h3 className="category-secondary-color">Template Details</h3>
                                                    
                                                    </div>

                                                    <div>
                                                        
                                                        <p>Please fill in the template details below.</p>

                                                    </div>

                                                </div>
                                                
                                            </div>
                                            

                                            <div className="create-checklist-section-a-information-container-container">

                                                <div className="duplicate-checklist-section-a-information-checklist-name-container-container">

                                                    <div className="duplicate-checklist-section-a-information-checklist-name-container">
                                        
                                                        {/* Template Name and Select Template */}
                                                        <div className="duplicate-section-information-template-name-select-template-detail-main-container">
                                                                {/* Select Template*/}
                                                                <div className="add-question-view-checklist-category-container">
                                    
                                                                <div>
                                                                    <h4>1. Select Template</h4>

                                                                    <p>Select the template you would like to use as the basis for creating your new template</p>
                                                                </div>

                                                                <div>
                                                                    <select
                                                                        value={selectedDocument}
                                                                        onChange={e => setSelectedDocument(e.target.value)}
                                                                        disabled={templateLoaded || isLoading}
                                                                    >
                                                                        <option value="">-- Select Template --</option>
                                                                        {documents.map(document => (
                                                                            <option key={document.shepack_document_id} value={document.shepack_document_id}>
                                                                                {document.shepack_document_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>

                                                                {editError && <div className="error-text">{editError}</div>}

                                                                <div>
                                                                    <p className="secondary-color-paragraph" style={{ fontStyle: 'italic' }}>Important: Click 'Load Template' to display the selected template along with its associated questions.</p>
                                                                </div>


                                                                {isPackSelected && !selectedDocument && <div className="info-text">*Required</div>}
                                                                
                                                                <div>
                                                                
                                                                    <button 
                                                                            className="confirm-button" 
                                                                            onClick={handleEditClick}
                                                                            disabled={templateLoaded || isLoading}
                                                                        >
                                                                            {isLoading ? (
                                                                                <>
                                                                                    <FaSpinner className="fa-spin" />
                                                                                    <span>Loading...</span>
                                                                                </>
                                                                            ) : (
                                                                                'Load Template'
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                    {isEditing && (
                                                                        <div className="duplicate-template-loaded-confirmation">
                                                                            <TiTick className="duplicate-template-selected-template-confirmation-icon" />

                                                                            <div>
                                                                                <p>Template loaded : {documents.find(doc => doc.shepack_document_id === selectedDocument)?.shepack_document_name}</p>
                                                                                <p>SHE File : {documents.find(doc => doc.shepack_document_id === selectedDocument)?.shepack_name || "N/A"}</p>
                                                                                <p className="template-info">You can now edit the template in Sections B and C.</p>
                                                                            </div>
                                                                            
                                                                        </div>
                                                                    )}
                                                                </div>
                                                        </div>
                                                    
                                                    </div>

                                        

                                        

                                        

                                        

                                    </div>

                                    

                                    
                                </div>
                                        </div>
                                    ) : section === 'B' ? (
                                        <div className="create-checklist-section-a-information-container">
                                            <div className="create-checklist-section-a-information-container-container">
                                                {categoryError && <p className="error-text">{categoryError}</p>}
                                            </div>
                                            <div className="create-checklist-section-a-information-container-container">
                                                <div className="create-checklist-section-a-information-checklist-category-container">

                                                    <div>
                                                        <p className="category-secondary-color">Create Question Category</p>
                                                        <p>To create a category, enter the category name in the input field and click the "Save Category" button to save it.<br /><br /> Saved categories will appear in the saved categories box</p>

                                                    </div>

                                                    <div className="create-checklist-section-a-information-container">

                                                        <div>
                                                            <input
                                                                className="create-checklist-questions-form-name-input"
                                                                placeholder="Enter Category name"
                                                                value={newCategory}
                                                                onChange={(e) => {
                                                                    setNewCategory(e.target.value);
                                                                    setCategoryError("");
                                                                }}
                                                            />

                                                        </div>

                                                        <div>

                                                            <button type="button" onClick={handleAddCategory} className="confirm-button">Save Category</button>

                                                        </div>

                                                        
                                                        

                                                    </div>
                                                    
                                                    
                                                    
                                                </div>
                                                <div className="create-checklist-section-a-information-checklist-saved-category-container">
                                                    <h4>Saved Categories</h4>
                                                    <p>To edit a category, click on the pen icon. <br /><br />Please remember to save your changes by clicking the green tick.</p>
                                                    <div className="create-checklist-section-a-information-checklist-saved-category-list-container">
                                                        {categories.length === 0 ? (
                                                            <div className="add-question-view-checklist-no-categories-message">
                                                                <p style={{ fontStyle: 'italic' }}>No categories have been added yet.</p>
                                                            </div>
                                                        ) : (
                                                            categories.map((category, index) => (
                                                                <div key={index} className="add-question-view-checklist-category-list-item-main-container">
                                                                    {editingCategory === category ? (
                                                                        <div className="add-question-view-checklist-category-list-item-container">
                                                                            <input
                                                                                value={editedCategoryName}
                                                                                onChange={(e) => setEditedCategoryName(e.target.value)}
                                                                                className="add-question-view-checklist-category-list-input"
                                                                            />
                                                                            <div className="add-question-view-checklist-icon-container">
                                                                                <TiTick className="add-question-view-checklist-tick-icon-container" onClick={() => {
                                                                                    if (editedCategoryName.trim() === "") {
                                                                                        setCategoryError("Category name cannot be empty");
                                                                                        return;
                                                                                    }
                                                                                    if (categories.includes(editedCategoryName) && editedCategoryName !== editingCategory) {
                                                                                        setCategoryError("This category name already exists");
                                                                                        return;
                                                                                    }
                                                                                    setCategories(prevCategories => prevCategories.map(cat => cat === editingCategory ? editedCategoryName : cat));
                                                                                    setQuestionBankData(prevData => prevData.map(row => ({ ...row, category: row.category === editingCategory ? editedCategoryName : row.category })));
                                                                                    setEditingCategory(null);
                                                                                    setEditedCategoryName("");
                                                                                    setCategoryError("");
                                                                                    setShowToaster(prev => ({ ...prev, editedCategory: true }));
                                                                                }} />
                                                                                <MdOutlineCancel className="add-question-view-checklist-cancel-icon-container" onClick={() => {
                                                                                    setEditingCategory(null);
                                                                                    setEditedCategoryName("");
                                                                                    setCategoryError("");
                                                                                    setShowToaster(prev => ({ ...prev, cancelEditedCategory: true }));
                                                                                }} />
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="add-question-view-checklist-category-list-item-container">
                                                                            <span>{category}</span>
                                                                            <CiEdit className="add-question-view-checklist-category-list-item-edit-icon" onClick={() => {
                                                                                setEditingCategory(category);
                                                                                setEditedCategoryName(category);
                                                                            }} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="add-question-view-fillin--checklist-table-container">
                                            <div className="add-question-view-checklist-table-table-container">
                                                <table className="create-questions-view-fillin-checklist-table">
                                                    <colgroup>
                                                        <col style={{ width: "50px" }} />
                                                        <col style={{ width: "150px" }} />
                                                        <col style={{ width: "300px" }} />
                                                        <col style={{ width: "150px" }} />
                                                        <col style={{ width: "150px" }} />
                                                        <col style={{ width: "150px" }} />
                                                        <col style={{ width: "150px" }} />
                                                        {Array.from({ length: visibleOptions }, (_, i) => <col key={i} style={{ width: "150px" }} />)}
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            {visibleColumnNames.map((columnName, index) => (
                                                                <th key={index} className="table-header">
                                                                    {columnName === 'Remove' ? '' : columnName}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody className="view-table-body">
                                                        {questionBankData.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={visibleColumnNames.length}>No Questions added to checklist, click 'add row' to add a question.</td>
                                                            </tr>
                                                        ) : (
                                                            questionBankData.map((row, rowIndex) => (
                                                                <tr key={rowIndex}>
                                                                    <td>
                                                                        <button onClick={() => handleRemoveRow(rowIndex)} className="remove-row-button">
                                                                            <MdDeleteOutline className='delete-checklist-submition-icon' />
                                                                        </button>
                                                                    </td>
                                                                    <td>
                                                                        <select
                                                                            value={row['question_type'] || 'Radio'}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'question_type', e.target.value)}
                                                                        >
                                                                            {questionTypes.map((type, index) => (
                                                                                <option key={index} value={type}>{type}</option>
                                                                            ))}
                                                                        </select>
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            value={row['question_name'] || ''}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'question_name', e.target.value)}
                                                                            placeholder="Enter question name"
                                                                            className="create-questions-form-question-input-column"
                                                                        />
                                                                    </td>

                                                                    {/* Column - question reference input field*/}
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            value={row['question_reference'] || ''}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'question_reference', e.target.value)}
                                                                            placeholder="Enter question reference"
                                                                            className="create-questions-form-question-input-column"
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row['question_score'] || ''}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'question_score', e.target.value)}
                                                                            placeholder="Score"
                                                                            className="create-questions-form-question-number-input-column"
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <select
                                                                            value={row['category'] || ''}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'category', e.target.value)}
                                                                        >
                                                                            <option value="">{'No category selected'}</option>
                                                                            {categories.map((category, index) => (
                                                                                <option key={index} value={category}>{category}</option>
                                                                            ))}
                                                                        </select>
                                                                    </td>

                                                                    <td>
                                                                        <select
                                                                            value={row['is_File_required'] || 'No'}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'is_File_required', e.target.value)}
                                                                        >
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    </td>

                                                                    {/*
                                                                    <td>
                                                                        <select
                                                                            value={row['is_mandatory'] || 'No'}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'is_mandatory', e.target.value)}
                                                                        >
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    </td>
                                                                    
                                                                    */}
                                                                    

                                                                    <td>
                                                                        <select
                                                                            value={row['comment'] || 'No'}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'comment', e.target.value)}
                                                                        >
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    </td>

                                                                    {/*

                                                                    <td>
                                                                        <select
                                                                            value={row['expires'] || 'No'}
                                                                            onChange={(e) => handleInputChange(rowIndex, 'expires', e.target.value)}
                                                                        >
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    </td>
                                                                    
                                                                    
                                                                    */}

                                                                    
                                                                    
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                                <div>
                                                   
                                                    <p className="secondary-color-paragraph"><i>Click the clear options button to reset all remove all the questions.</i></p>
                                                </div>
                                                {errors.length > 0 && (
                                                    <div className="error-text">
                                                        <ul>
                                                            {errors.map((error, index) => (
                                                                <li key={index}>{error}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                                <div className="add-row-add-option-container">
                                                    <button onClick={handleAddRow} className="confirm-button-response">Add Question</button>
                                                    <button onClick={handleClearQuestions} className="cancel-button">Clear Questions</button>
                                                </div>
                                                {optionError && <div className="error-text">{optionError}</div>}
                                                <div style={{ textAlign: 'center' }}>
                                                    <p>By clicking 'Update Template' template information will be updated.</p>
                                                </div>
                                                <div className="add-question-submit-clear-button-container">
                                                    <button onClick={handleSubmit} className="confirm-button" disabled={submitStatus === 'loading'}>
                                                        {submitStatus === 'loading' ? (
                                                            <>
                                                                <FaSpinner className="fa-spin" />
                                                                <span className="submitting-questions-text"> Creating Template...</span>
                                                            </>
                                                        ) : (
                                                            'Update Template'
                                                        )}
                                                    </button>
                                                    <button onClick={handleReset} className="cancel-button">Reset Template</button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            
            {showToaster.rowAdded && <ItemAddedToaster item={'Question Row Added'} />}
            {showToaster.rowRemoved && <ItemRemovedToaster item={'Question Row Deleted'} />}
            {showToaster.optionAdded && <ItemAddedToaster item={'Option Added'} />}
            {showToaster.categoryAdded && <ItemAddedToaster item={'Category Added'} />}
            {showToaster.editedCategory && <ItemAddedToaster item={'Category name edited'} />}
            {showToaster.cancelEditedCategory && <ItemAddedToaster item={'Category Edit Cancelled'} />}
            
            {showSuccess && 
        
                <CreatedSuccesFullyToaster
                    heading='Template Edited Successfully'
                />
            }
            
            
        </div>
    );
};

export default EditTemplateComponent;